import React, { useEffect ,useState} from 'react';
import UseLangLstQuery from 'Apis/LangTxtInqApi';
import { useNavigate ,useLocation, Link} from "react-router-dom";
import BlckMembInqApi from 'Apis/BlckMembInqApi';
import MgpStore from 'Stores/Store';
import MembLvdRqstApi from 'Apis/MembLvdRqstApi';
import MembLvdCnclApi from 'Apis/MembLvdCnclApi';
import 'Assets/css/BlckMemb.css';
import MembNrmlLogoutApi from 'Apis/MembNrmlLogoutApi';
import ApiResultModal from 'Components/ApiResultModal';
import { Helmet } from 'react-helmet-async';

const AppMembLvdCnclUi = () => {
    const location = useLocation(); 
    const [blckMembState, setBlckMembState] = useState<any>();
    const [lvdDtimeState, setLvdDtimeState] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);
    const {isLoading,error,data: langData}:any = UseLangLstQuery();

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) action();
    };
    useEffect(()=>{
        MembLvdRqstApi().then((resp)=>{
            setLvdDtimeState(resp.lvdDtime);
             
        });
    },[MgpStore.getState().LangSetState.Lang]);
    const navigate = useNavigate();
    const MembLvdCnclFunc = () => {
        MembLvdCnclApi().then((resp)=>{
            if(resp.apiBody == true){
                openResultModal("탈퇴 철회가 완료되었습니다.", () => navigate("/", { replace: true }));
            }
        });
    }
    const logoutFunc = () => {
        MembNrmlLogoutApi()
        .then((resp)=>{
           navigate("/", { replace: true });
        });        
    }
    return(
        <>
        <Helmet>
            <title>BE@RBRICK CONNECT - Cancel Membership Withdrawal</title>
        </Helmet>
            <ApiResultModal
                open={resultModalOpen}
                message={resultModalMessage}
                onClose={closeResultModal}
                confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
                app={"app"}
            />
            <div className='loginInputWrap'>
                <div className='membFindTitl'>
                    <h1>{langData&&langData.LOGIN_MEMB_LVD_MAIN_TITL_00}</h1>
                    <div className='blckMembIcon'>
                        <img src={process.env.PUBLIC_URL+"/images/common/blckMembIcon3.png"} alt="블럭회원 아이콘" />
                    </div>
                </div>
                <div className='blckNoticeWrap'>
                    <p className='blckKindNm' dangerouslySetInnerHTML={{
                        __html: langData&&langData.LOGIN_MEMB_LVD_MAIN_DESC_00
                    }}></p>
                    <p className='dateP'>{langData&&langData.LOGIN_MEMB_LVD_DATE_DESC_00} ~ {lvdDtimeState}</p>
                </div>
                <div className='blckBtnWrap'>
                    <button onClick={()=>logoutFunc()} className='buttonBgB'>
                        <p>{langData&&langData.COMM_MAIN_HOME_MAIN_BTN_00}</p>
                    </button>
                    <button onClick={()=>MembLvdCnclFunc()} className='buttonBgB'>
                        <p>{langData&&langData.LOGIN_MEMB_LVD_CNCL_BTN_00}</p>
                    </button>
                </div>
            </div>
        </>
    )
}

export default AppMembLvdCnclUi;